<template>
  <div>
    <h1 class="display-4">{{ h1 }}</h1>
    <hr />

    <b-form>
      <b-form-group label-for="Schools">
        <template slot="label">
          Ecole <span class="text-danger">*</span>
        </template>
        <b-form-select id="Schools" name="Schools" v-model="schoolId" :options="schools" data-vv-as="Ecole" v-validate="'required'"></b-form-select>
        <div v-show="errors.has('Schools')" class="alert alert-danger mt-3">{{ errors.first('Schools') }}</div>
      </b-form-group>
      <b-form-group label-for="Cities">
        <template slot="label">
          Ville <span class="text-danger">*</span>
        </template>
        <b-form-select id="Cities" name="Cities" v-model="cityId" :options="cities" data-vv-as="Ville" v-validate="'required'"></b-form-select>
        <div v-show="errors.has('Cities')" class="alert alert-danger mt-3">{{ errors.first('Cities') }}</div>
      </b-form-group>
      <b-form-group label="Adresse" label-for="adresse">
        <b-form-input id="adresse" name="adresse" placeholder="Adresse de l'école" v-model="address"></b-form-input>
      </b-form-group>
      <b-form-group label="Code postal" label-for="code_postal">
        <b-form-input id="code_postal" name="code_postal" placeholder="Code postal de l'école" v-model="zip_code"></b-form-input>
      </b-form-group>
      <b-form-group label="Ville" label-for="ville">
        <b-form-input id="ville" name="ville" placeholder="Ville de l'école" v-model="ville"></b-form-input>
      </b-form-group>
      <b-form-group label="Lien Google Maps" label-for="map">
        <b-form-input id="map" name="map" placeholder="Lien Google Maps" v-model="map"></b-form-input>
      </b-form-group>
      <b-btn type="submit" variant="primary" @click.prevent="edit">{{ button }}</b-btn>
      <router-link to="/establishments/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </b-form>

    <div v-show="id != null">
      <h2 class="mt-5">Liste des utilisateurs</h2>
      <hr />
      <b-form-group>
          <b-form-checkbox-group
          id="checkbox-group-1"
          v-model="users_selected"
          :options="users"
          name="establishments"
          stacked
          ></b-form-checkbox-group>
      </b-form-group>
      <b-btn variant="primary" @click.prevent="editUsers">Mettre à jour la liste des utilisateurs</b-btn>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      address: '',
      button: '',
      cities: [{ value: '', text: '--- Sélectionnez une ville ---' }],
      cityId: '',
      h1: '',
      map: '',
      previous_id: [],
      schoolId: '',
      schools: [{ value: '', text: '--- Sélectionnez une école ---' }],
      users: [],
      users_selected: [],
      ville: '',
      zip_code: ''
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.schoolId !== '' && this.cityId !== '') {
            if (!this.id) {
              this.$http.post(this.domain + '/api/establishments?access_token=' + this.access_token, { address: this.address, zip_code: this.zip_code, ville: this.ville, map: this.map, schoolId: this.schoolId, cityId: this.cityId }, { emulateJSON: true }).then((response) => {
                response.json().then((data) => {
                  if (response.status === 200 && response.ok) {
                    this.$root.$bvToast.toast('L\'établisement a bien été ajouté', {
                      title: 'Etablissement ajouté',
                      autoHideDelay: 3000,
                      append: false,
                      variant: 'success'
                    })
                    this.$router.push('/establishments/list')
                  }
                })
              }, (response) => {

              })
            } else {
              this.$http.post(this.domain + '/api/establishments/' + this.id + '/replace?access_token=' + this.access_token, { address: this.address, zip_code: this.zip_code, ville: this.ville, map: this.map, schoolId: this.schoolId, cityId: this.cityId }, { emulateJSON: true }).then((response) => {
                response.json().then((data) => {
                  if (response.status === 200 && response.ok) {
                    this.$root.$bvToast.toast('L\'établissement a bien été modifié', {
                      title: 'Etablissement modifié',
                      autoHideDelay: 3000,
                      append: false,
                      variant: 'success'
                    })
                    this.$router.push('/establishments/list')
                  }
                })
              }, (response) => {

              })
            }
          }
        }
      })
    },
    editUsers () {
      for (let j = 0; j < this.previous_id.length; j++) {
        this.$http.delete(this.domain + '/api/establishments_ionis/' + this.previous_id[j] + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {

          })
        }, (response) => {

        })
      }
      for (let i = 0; i < this.users_selected.length; i++) {
        this.$http.post(this.domain + '/api/establishments_ionis/replaceOrCreate?access_token=' + this.access_token, { establishmentId: this.id, ionisId: this.users_selected[i] }, { emulateJSON: true }).then((response) => {
          response.json().then((data) => {
            if (response.status === 200 && response.ok) {
              this.$router.push('/establishments/list')
            }
          })
        }, (response) => {

        })
      }
    }
  },
  mounted () {
    if (this.id) {
      this.$http.get(this.domain + '/api/establishments/' + this.id + '?access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.schoolId = data.schoolId
          this.cityId = data.cityId
          this.address = data.address
          this.zip_code = data.zip_code
          this.ville = data.ville
          this.map = data.map
        })
      }, (response) => {

      })
      this.button = 'Editer'
      this.h1 = 'Editer un établissement'
    } else {
      this.button = 'Valider'
      this.h1 = 'Ajouter un établissement'
    }

    // Récupération des écoles et des villes
    this.$http.get(this.domain + '/api/schools?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        for (let i = 0; i < data.length; i++) {
          this.schools.push(
            {
              value: data[i].id,
              text: data[i].name
            }
          )
        }
      })
    }, (response) => {

    })

    this.$http.get(this.domain + '/api/cities?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        for (let i = 0; i < data.length; i++) {
          this.cities.push(
            {
              value: data[i].id,
              text: data[i].name
            }
          )
        }
      })
    }, (response) => {

    })

    // Récupération des utilisateurs et des établissements / utilisateurs
    this.$http.get(this.domain + '/api/ionis?filter[where][role][neq]=API&access_token=' + this.access_token).then((response) => {
      response.json().then((data) => {
        // this.users = data
        for (let i = 0; i < data.length; i++) {
          this.users.push({
            text: data[i].first_name + ' ' + data[i].last_name,
            value: data[i].id
          })
        }
      })
    }, (response) => {

    })
    this.$http.get(this.domain + '/api/establishments_ionis?filter[where][establishmentId]=' + this.id + '&filter[include][ionis]&access_token=' + this.access_token, { emulateJSON: true }).then((response) => {
      response.json().then((data) => {
        for (let i = 0; i < data.length; i++) {
          this.users_selected.push(data[i].ionisId)
          this.previous_id.push(data[i].id)
        }
      })
    }, (response) => {

    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Establishments/Edit.vue